import { FormHelperText } from '@mui/material'
import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useLoadOptions } from 'src/hooks/useLoadOptions'
import CardActions from 'src/pages/sistema/components/CardActions'
import { useAFOPUAforoTipos } from '../hooks/useAFOPUCache'
import { useAFOPUTablaValorInicial } from '../hooks/useTablaValorAFOPU'
import { OperacionAFOPUFields, OperacionAFOPUTablaValorFields } from '../types/fields'
import { FormOperacionAFOPU } from '../types/types'
import AFOPUTablaValoresEditorGrid from './AFOPUTablaValoresEditorGrid'

interface SeccionNuevoAFOPUTablaValoresProps {
  formMethods: UseFormReturn<FormOperacionAFOPU>
  codSistemaPrincipal: number
}

const SeccionNuevoAFOPUTablaValores = ({ formMethods, codSistemaPrincipal }: SeccionNuevoAFOPUTablaValoresProps) => {
  const { headers, rows, aforos, isLoading } = useAFOPUTablaValorInicial(codSistemaPrincipal);

  const aforoTipos = useAFOPUAforoTipos(codSistemaPrincipal);
  const loadAforoTipos = useLoadOptions({
    data: aforoTipos.aforoTipos,
    loading: aforoTipos.isLoading,
    isError: aforoTipos.isError,
    error: aforoTipos.error
  });

  useEffect(() => {
    if (aforos && aforos.length > 0) {
      const dataParaFormulario = aforos.map((item) => ({
        [OperacionAFOPUTablaValorFields.CodInstrumento]: item[OperacionAFOPUTablaValorFields.CodInstrumento],
        [OperacionAFOPUTablaValorFields.DescInstrumento]: item[OperacionAFOPUTablaValorFields.DescInstrumento],
        [OperacionAFOPUTablaValorFields.CodOperacionTipo]: item[OperacionAFOPUTablaValorFields.CodOperacionTipo],
        [OperacionAFOPUTablaValorFields.DescOperacionTipo]: item[OperacionAFOPUTablaValorFields.DescOperacionTipo],
        [OperacionAFOPUTablaValorFields.Valor]: item[OperacionAFOPUTablaValorFields.Valor],
        [OperacionAFOPUTablaValorFields.OrdenInstrumento]: item.ordenInstrumento ?? 0,
      }));

      formMethods.setValue(OperacionAFOPUFields.TablaValores, dataParaFormulario);
    }
  }, [aforos, formMethods]);

  return (
    <CardActions title='Tabla de Valores' icon='mdi:table-edit' colapsable tableContent>
      <AFOPUTablaValoresEditorGrid
        formMethods={formMethods}
        headers={headers}
        rows={rows}
        aforos={aforos || []}
        loadAforoTipos={loadAforoTipos}
        isLoading={isLoading}
        permiteEditar={true}
      />

      {formMethods.formState.errors.tablaValores?.message && (
        <FormHelperText error sx={{ px: 2, pb: 1 }}>
          {formMethods.formState.errors.tablaValores.message}
        </FormHelperText>
      )}
    </CardActions>
  )
}

export default SeccionNuevoAFOPUTablaValores;